/**
 * Temporarily applies a highlight effect to an element
 * Adds a CSS class to create a visual effect and removes it after a delay
 *
 * @param element The HTML element to highlight
 * @param duration Time in milliseconds to keep the highlight (defaults to 4000ms)
 */
export function highlightElement(element: HTMLElement, duration = 4000): void {
  // Add highlight class
  element.classList.add("highlight-effect");

  // Remove the class after animation completes
  setTimeout(() => {
    element.classList.remove("highlight-effect");
  }, duration);
}
